import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { ResourceList } from '@/Core/UI/CrudResource'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { UserResource } from '../Resources/UserResource'
import { InvitationUserDrawer } from '../Components/Modals/InvitationUserDrawer'
import { IPageConfig } from '@/Core/Contracts/UI'
import { FaRegUser } from 'react-icons/fa'

const UserPage = observer(() => {
    const listContext = useMemo(() =>
        createCrudResourceContext({
            contextType: 'list',
            registryKey: 'Setting.User.list',
            resource: UserResource,
        } as any), [])

    const inviteOpen: boolean = listContext.states?.openInviteDrawer === true

    return (
        <>
            <ResourceList crudContext={listContext} />
            <InvitationUserDrawer
                crudContext={listContext}
                title="Запросити співробітника"
                open={inviteOpen}
                onClose={() => listContext.setState('openInviteDrawer', false)}
            />
        </>
    )
})

export const pageConfig: IPageConfig = {
    route: '/users',
    title: 'Співробітники',
    icon: <FaRegUser />,
}

export default UserPage
